module.exports = __webpack_public_path__ + "static/media/assa-checkmark.5fd532f3.svg";